var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNotBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.212,4.231,3.385,12.269,0,22l9.731-3.173L17.558,11ZM21.154,3.6,18.4.846a2.565,2.565,0,0,0-3.808,0L12.269,3.173l6.346,6.558,2.538-2.538A2.681,2.681,0,0,0,22,5.288,2.611,2.611,0,0,0,21.154,3.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNotBackground);
export default __webpack_public_path__ + "static/media/EditNotBackground.25b155ff2e16dec77908fcd4bc2dcca2.svg";
export { ForwardRef as ReactComponent };